import { render } from "./Subject_management_edit.vue?vue&type=template&id=42cb2893&scoped=true"
import script from "./Subject_management_edit.vue?vue&type=script&lang=js"
export * from "./Subject_management_edit.vue?vue&type=script&lang=js"

import "./Subject_management_edit.vue?vue&type=style&index=0&id=42cb2893&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42cb2893"]])

export default __exports__